import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { MeiliSearchSearchState } from '../../../../hooks/meilisearch/types/meilisearch-search-state';

export const spaceGroupsKeys = {
  all: ['space-groups'] as const,
  lists: () => [...spaceGroupsKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState | MeiliSearchSearchState,
  ) =>
    [
      ...spaceGroupsKeys.lists(),
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
  details: () => [...spaceGroupsKeys.all, 'detail'] as const,
  detail: (token: string) => [...spaceGroupsKeys.details(), token] as const,
};
